import {
  PublicDocCategory,
  PublicDocFile,
} from '@app/admin/docs/public-doc';

const ROOT = '';

export interface DocsCategoryGroup {
  path: string;
  title: string;
  files: PublicDocFile[];
}

export function groupDocsByCategory(
  files: PublicDocFile[],
  categories: PublicDocCategory[],
): DocsCategoryGroup[] {
  const byCategory = new Map<string, PublicDocFile[]>();

  for (const file of files) {
    const key = file.category || ROOT;
    if (!byCategory.has(key)) {
      byCategory.set(key, []);
    }
    byCategory.get(key)!.push(file);
  }

  const groups: DocsCategoryGroup[] = [];
  const rootFiles = byCategory.get(ROOT) ?? [];
  if (rootFiles.length) {
    groups.push({path: ROOT, title: 'General', files: rootFiles});
  }

  const sorted = [...categories].sort((a, b) => {
    if (a.order !== b.order) return a.order - b.order;
    return a.title.localeCompare(b.title);
  });

  for (const cat of sorted) {
    groups.push({
      path: cat.path,
      title: cat.title,
      files: byCategory.get(cat.path) ?? [],
    });
  }

  for (const [path, catFiles] of byCategory) {
    if (path === ROOT) continue;
    if (categories.some(c => c.path === path)) continue;
    groups.push({
      path,
      title: path.split('/').pop() ?? path,
      files: catFiles,
    });
  }

  return groups;
}
